const LogUTM = {
  insert: "/api/LogUTM/insert"
};

export default LogUTM;
